import { render } from "./Permissions-page.vue?vue&type=template&id=7f697826&scoped=true"
import script from "./Permissions-page.vue?vue&type=script&lang=js"
export * from "./Permissions-page.vue?vue&type=script&lang=js"

import "./Permissions-page.vue?vue&type=style&index=0&id=7f697826&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f697826"]])

export default __exports__